var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16669 4.83317H9.83335V6.49984H8.16669V4.83317ZM8.16669 8.1665H9.83335V13.1665H8.16669V8.1665ZM9.00002 0.666504C4.40002 0.666504 0.666687 4.39984 0.666687 8.99984C0.666687 13.5998 4.40002 17.3332 9.00002 17.3332C13.6 17.3332 17.3334 13.5998 17.3334 8.99984C17.3334 4.39984 13.6 0.666504 9.00002 0.666504ZM9.00002 15.6665C5.32502 15.6665 2.33335 12.6748 2.33335 8.99984C2.33335 5.32484 5.32502 2.33317 9.00002 2.33317C12.675 2.33317 15.6667 5.32484 15.6667 8.99984C15.6667 12.6748 12.675 15.6665 9.00002 15.6665Z",
    fill: "#2B5297"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-Icon.96831b1d8b0512e572e783b8a5786941.svg";
export { ForwardRef as ReactComponent };